/**
 * Mutations for updating the state via actions.
 * Names should reference from mutation types
 */

import * as types from './mutation-types';

export const mutations = {
  [types.SET_FILTER_LIMIT] (state, limit) {
    state.props.limit = limit
  },
  [types.SET_LINKS] (state, payload) {
    state.links = payload
  },
  [types.SET_MAX_QUERY_SIZE](state, limit) {
		state.largestQuerySize = limit
	}
};
